import React from "react";
import PropTypes from "prop-types";
import { HugeiconsIcon } from "@hugeicons/react";
import InboxIcon from "@hugeicons/core-free-icons/InboxIcon";

// Generic empty-state placeholder: an icon, a title, an optional hint line,
// and an optional action slot (e.g. a "Clear filters" button) supplied by
// the caller — this component has no opinion about what caused the
// emptiness or what the action should do.
function EmptyState({ icon, title, hint, action }) {
    return (
        <div className="flex flex-col items-center justify-center gap-2 px-6 py-16 text-center font-sans">
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-gray-200 text-gray-500">
                {icon || <HugeiconsIcon icon={InboxIcon} size={22} />}
            </span>
            <p className="text-lg font-semibold text-black">{title}</p>
            {hint && <p className="text-sm text-gray-500">{hint}</p>}
            {action && <div className="mt-2">{action}</div>}
        </div>
    );
}

EmptyState.propTypes = {
    icon: PropTypes.node,
    title: PropTypes.node,
    hint: PropTypes.node,
    action: PropTypes.node,
};

EmptyState.defaultProps = {
    icon: null,
    title: "Nothing to show here",
    hint: null,
    action: null,
};

export default EmptyState;
